



























































































import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Thumbs, Lazy, Swiper, Keyboard } from 'swiper'
import { mdiChevronUp, mdiChevronDown, mdiAccountCircleOutline } from '@mdi/js'
import { IImageMeta, IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'
import 'swiper/swiper.scss'
import ComponentIntersect from '~/components/intersect/intersect.vue'
import ComponentImageVideo from '~/components/images/gallery-video.vue'
import ComponentImage from '~/components/images/image.vue'
import ComponentFormButtonIcon from '~/components/form/button-icon.vue'
import ComponentImageUploadPhoto from '~/components/images/upload-photo.vue'
import ComponentIcon from '~/components/icon/icon.vue'
import ComponentImageWithZoom from '~/components/images/image-with-zoom.vue'

Swiper.use([Thumbs, Lazy, Keyboard])

interface IImageGalleryItem {
  medium: IImageVariants[]
  small: IImageVariants[]
  large: IImageVariants[]
  lazyLoad?: string
  isUserPhoto?: boolean
  meta?: IImageMeta
}

@Component({
  components: {
    ComponentIntersect,
    ComponentImageWithZoom,
    ComponentImage,
    ComponentFormButtonIcon,
    ComponentImageUploadPhoto,
    ComponentIcon,
    ComponentImageVideo,
  },
})
export default class ComponentImageGallery extends Vue {
  @Prop({ type: Number, default: -1 }) readonly productId!: number
  @Prop({ default: false, type: Boolean }) readonly canUpload!: boolean
  @Prop({ default: false, type: Boolean }) readonly canZoom!: boolean
  @Prop({ default: false, type: Boolean }) readonly hasVideo!: boolean
  @Prop({ default: 0, type: Number }) readonly start!: number
  @Prop({ default: false, type: Boolean }) readonly popup!: boolean
  @Prop({ type: String, default: '1 / 1' }) readonly ratio!: string
  @Prop({ type: String, default: 'large' }) readonly imageDefaultType!: string
  @Prop({ default: false, type: Boolean }) readonly pointer!: boolean
  @Prop({
    type: Array,
    default: () => {},
  })
  private items!: IImageGalleryItem[]

  private swiperLarge!: Swiper
  private swiperSmall!: Swiper
  private $style!: IStyle
  private isCanUploadMounted = false

  private icons = {
    mdiChevronUp,
    mdiChevronDown,
    mdiAccountCircleOutline,
  }

  private get isShowNavigation() {
    return this.items.length > 6
  }

  private mounted() {
    const bigPhotoContainer: HTMLElement = this.$refs
      .bigPhotoContainer as HTMLElement
    const smallPhotoContainer: HTMLElement = this.$refs
      .smallPhotoContainer as HTMLElement

    if (bigPhotoContainer && smallPhotoContainer) {
      this.swiperSmall = new Swiper(smallPhotoContainer, {
        direction: 'vertical',
        touchMoveStopPropagation: true,
        slidesPerView: this.popup && window.innerHeight < 600 ? 4 : 6,
        spaceBetween: 16,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
      })

      this.swiperLarge = new Swiper(bigPhotoContainer, {
        touchMoveStopPropagation: true,
        thumbs: {
          swiper: this.swiperSmall,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      })
      this.swiperLarge.slideTo(this.start)
    }
    this.isCanUploadMounted = this.canUpload
  }

  private slidePrev() {
    if (this.swiperLarge.isBeginning) {
      this.swiperLarge.slideTo(this.items.length - 1)
    } else {
      this.swiperLarge.slidePrev()
    }
  }

  private slideNext() {
    if (this.swiperLarge.isEnd) {
      this.swiperLarge.slideTo(0)
    } else {
      this.swiperLarge.slideNext()
    }
  }

  private clickSlide(slide: number) {
    this.$emit('click', slide)
  }

  private get classBigPhotoItem() {
    return {
      [this.$style.bigPhotoItem]: true,
      [this.$style.pointer]: this.pointer,
    }
  }

  private get styleSwiperContainer() {
    let height = ((1 / eval(this.ratio)) * ((this.popup  && window.innerHeight < 600) ? 4 : 6) * 74 + 80); // eslint-disable-line
    if (height > 650) {
      height = 650
    }
    return {
      height: height.toString() + 'px',
    }
  }
}
